import { Flex, Grid, Stack } from '@chakra-ui/react';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import amplo from '@public/investors/amplo.svg';
import define from '@public/investors/define.svg';
import slow from '@public/investors/slow.svg';
import yc from '@public/investors/yc.svg';
import Image from 'next/image';

const Investors = () => {
  return (
    <Flex bg="tan" px={antlerStyle.px} py={['60px', '60px', '80px']} w="100%">
      <Stack alignItems="center" w="100%" gap={20}>
        <Header as="h2">Our Investors</Header>
        <Grid
          templateColumns={['1fr', '1fr', '1fr 1fr', 'repeat(4, 1fr)']}
          gap={[16, 8, 12, '120px']}
          justifyContent="center"
          alignItems="center"
          sx={{ '> div': { flex: 1, maxW: ['160px', '180px', '240px', '300px'], justifyContent: 'center' } }}
        >
          <Flex>
            <Image src={define} alt="Define Ventures Logo" />
          </Flex>
          <Flex>
            <Image src={slow} alt="Slow Ventures Logo" />
          </Flex>
          <Flex>
            <Image src={yc} alt="Y Combinator Logo" />
          </Flex>
          <Flex>
            <Image src={amplo} alt="Amplo Logo" />
          </Flex>
        </Grid>
      </Stack>
    </Flex>
  );
};

export default Investors;
